var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolylineDeduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4581",
    height: "24px",
    width: "24px",
    viewBox: "0 0 24 24",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89886529,0,0,0.97221528,2.6962897,3.0995864)",
    id: "g5143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5274"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 4.5,2 C 3.1,2 2,3.1 2,4.5 2,5.9 3.1,7 4.5,7 4.8,7 5.1003906,6.9007813 5.4003906,6.8007812 L 6.5996094,8 5.4003906,9.1992188 C 5.1003906,9.0992188 4.8,9 4.5,9 3.1,9 2,10.1 2,11.5 2,12.9 3.1,14 4.5,14 5.9,14 7,12.9 7,11.5 7,11.2 6.9007812,10.8 6.8007812,10.5 L 7.9003906,9.4003906 11.300781,13 H 14 L 6.8007812,5.5 C 6.9007813,5.2 7,4.8 7,4.5 7,3.1 5.9,2 4.5,2 Z M 11.300781,3 8.5996094,5.9003906 9.9003906,7.3007812 14,3 Z M 4.5,3.5 c 0.5,0 1,0.5 1,1 0,0.5 -0.5,1 -1,1 -0.5,0 -1,-0.5 -1,-1 0,-0.5 0.5,-1 1,-1 z m 3.3066406,4.1875 c 0.173,0 0.3125,0.1395 0.3125,0.3125 0,0.173 -0.1385468,0.3125 -0.3105468,0.3125 C 7.6355937,8.3125 7.4941406,8.173 7.4941406,8 c 0,-0.173 0.1405,-0.3115 0.3125,-0.3125 z M 4.5,10.5 c 0.5,0 1,0.5 1,1 0,0.5 -0.5,1 -1,1 -0.5,0 -1,-0.5 -1,-1 0,-0.5 0.5,-1 1,-1 z",
    id: "path4579",
    transform: "matrix(1.1125138,0,0,1.0285788,-2.9996594,-3.1881688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5",
    d: "m 6.4902549,17.512446 -1.5385668,1.551457 1.4140624,1.414063 1.5385678,-1.551457 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-1",
    d: "M 8.9419765,15.046404 7.4034097,16.597861 8.8174721,18.011924 10.35604,16.460467 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-7",
    d: "m 11.346138,12.640575 -1.5385673,1.551457 1.4140623,1.414063 1.538568,-1.551456 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-8",
    d: "m 13.764441,10.208595 -1.538567,1.551457 1.414062,1.414063 1.538568,-1.551457 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-2",
    d: "m 16.158212,7.8388709 -1.538567,1.5514575 1.414063,1.4140626 1.538568,-1.5514566 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-78",
    d: "m 18.58821,5.3888054 -1.538567,1.551457 1.414063,1.4140627 1.538567,-1.5514566 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1
    },
    id: "path5132-5-85",
    d: "m 21.048208,2.9479856 -1.538567,1.551457 1.414062,1.414063 1.538568,-1.5514569 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolylineDeduction);
export default __webpack_public_path__ + "static/media/polyline-deduction.b47dde54.svg";
export { ForwardRef as ReactComponent };